module.exports = __webpack_public_path__ + "media/bureau.0dc5cae0.mp4";